import { render } from "./ArenaNavbar.vue?vue&type=template&id=2a28457d&scoped=true"
import script from "./ArenaNavbar.vue?vue&type=script&lang=js"
export * from "./ArenaNavbar.vue?vue&type=script&lang=js"

import "./ArenaNavbar.vue?vue&type=style&index=0&id=2a28457d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a28457d"]])

export default __exports__